import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import AreaPlot from "./AreaPlot";
import { Text } from "../../styles/Global";
import { usePlayerPPRMutation } from "../../services/playerApi";
import SkeletonLoader from "../../components/SkeletonLoader";
import { setChartData } from "../../features/player/chartDataSlice";

const mapDispatch = { setChartData };

const PPRChart = ({
  userID,
  requestBody,
  sport,
  FormatTimestamps,
  setChartData,
}) => {
  const savedChartData = useSelector((state) => state.chartData.playerPPR);
  const [data, setData] = useState(savedChartData);
  const [
    getPlayerPPR,
    { data: playerPPRData, error: playerPPRError, isLoading: playerPPRLoading },
  ] = usePlayerPPRMutation();
  console.log("Player PPR: ", playerPPRData);
  useEffect(() => {
    // console.log("getting Player PPR");
    getPlayerPPR(requestBody);
  }, []);
  useEffect(() => {
    if (playerPPRData) {
      setChartData({ playerPPR: playerPPRData });
      setData(playerPPRData);
    }
  }, [playerPPRData]);
  return data && data.statusCode === 0 ? (
    <div>
      {data && data.chart.length ? (
        <AreaPlot
          type="ppr"
          x="timestamp"
          y="ppr"
          data={FormatTimestamps(data.chart)}
        />
      ) : (
        <div
          style={{
            textAlign: "center",
            alignSelf: "center",
            marginTop: 25,
          }}
        >
          <Text>No PPR Data available yet</Text>
        </div>
      )}
    </div>
  ) : (
    <SkeletonLoader h1={200} />
  );
};

export default connect(null, mapDispatch)(PPRChart);
